import {
  siteThemeById,
  type SiteAccentId,
  type SiteThemeId,
} from "./siteThemes";

type SiteAccentPickerProps = {
  name: string;
  theme: SiteThemeId;
  value: SiteAccentId;
  busy?: boolean;
  onChange: (accent: SiteAccentId) => void;
};

/** Swatches for the accents the current theme offers. */
export const SiteAccentPicker = ({
  name,
  theme,
  value,
  busy,
  onChange,
}: SiteAccentPickerProps) => (
  <fieldset className="grid grid-cols-4 gap-2" aria-busy={busy}>
    <legend className="sr-only">Choose an accent colour</legend>
    {siteThemeById(theme).accents.map((accent) => {
      const selected = value === accent.id;
      return (
        <label
          key={accent.id}
          className="flex min-w-0 cursor-pointer flex-col items-center gap-1.5 text-xs text-hazumu-muted has-checked:font-semibold has-checked:text-hazumu-ink"
        >
          <input
            checked={selected}
            className="peer sr-only"
            name={name}
            onChange={() => onChange(accent.id)}
            type="radio"
            value={accent.id}
          />
          <span
            aria-hidden="true"
            data-site-theme={theme}
            data-site-accent={accent.id}
            className="grid size-11 place-items-center rounded-full border border-hazumu-border bg-site-bg ring-offset-2 ring-offset-transparent peer-checked:ring-2 peer-checked:ring-hazumu-terracotta peer-focus-visible:outline-2 peer-focus-visible:outline-offset-4 peer-focus-visible:outline-hazumu-ink"
          >
            <span className="size-7 rounded-full bg-site-accent" />
          </span>
          {accent.name}
        </label>
      );
    })}
  </fieldset>
);
